/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Item,
  Label,
  Loader,
  Menu,
  Popup,
  Segment,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { decodeSearch, encodeSearch } from '../../utils/url';
import PageNav from '../../components/PageNav';
import SearchFilter from '../../components/SearchFilter';
import { DatePicker, SelectListMultiple } from '../../components/Filters';
import DATE_RANGES from '../../constants/dateRanges';
import PROJECT_STATUSES from '../../constants/projectStatuses';
import LoadImage from '../../components/LoadImage';
import NavBar from '../../components/NavBar';
import SortButton from '../../components/SortButton';
import LoanAmount from '../../components/LoanAmount';
import SizeSuffix from '../../components/SizeSuffix';
import CurrencySymbol from '../../components/CurrencySymbol';
import { fetchM } from '../../actions/fetchM';
import { fetchProjectBusinessUnits } from '../../actions/projectBusinessUnits';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import STATES from '../../constants/states';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { isCountryVietnam } from '../../constants/countries';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    projectBusinessUnits: PropTypes.shape({
      data: PropTypes.array,
    }),
    t: PropTypes.func,
    projectPinsToken: PropTypes.string,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    projectBusinessUnits: state.projectBusinessUnits,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const count = props.count;
    const limit = props.limit || 10;
    const offset = props.offset || 0;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const pinnedData = props.projectPins || [];
    const pinnedProjects = pinnedData.map(item => ({
      ...item.project,
      pinned: true,
    }));
    const pinnedIdSet = new Set(pinnedProjects.map(p => p.id));
    const unpinnedProjects = (props.data || []).map(item => ({
      ...item,
      pinned: pinnedIdSet.has(item.id),
    }));
    const search = query.search || '';
    const advanceFilter = false;
    const dateRange = query.dateRange || '';
    const projectStatus = query.projectStatus || [];
    const projectBusinessUnit = query.projectBusinessUnit || [];
    const projectState = query.projectState || [];
    const dateFrom = query.dateFrom || '';
    const dateTo = query.dateTo || '';
    const hasFilter =
      projectStatus.length > 0 ||
      projectBusinessUnit.length > 0 ||
      projectState.length > 0 ||
      dateRange ||
      dateFrom ||
      dateTo ||
      search;
    const combinedProjects =
      currentPage === 1 && !hasFilter
        ? [...pinnedProjects, ...unpinnedProjects]
        : [...unpinnedProjects];
    return {
      data: combinedProjects,
      pinnedData,
      loading,
      count,
      limit,
      offset,
      currentPage,
      search,
      advanceFilter,
      dateRange,
      projectStatus,
      projectBusinessUnit,
      projectState,
      dateTo,
      dateFrom,
    };
  }
  constructor(props) {
    super(props);
    const projectBusinessUnits = props.projectBusinessUnits ?
      [].concat(props.projectBusinessUnits.data) : [];
    const state = List.getPropsToState(props);
    this.state = {
      ...state,
      projectBusinessUnits,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchProjectBusinessUnits(true));
  }
  componentWillReceiveProps(nextProps) {
    const projectBusinessUnits = nextProps.projectBusinessUnits ?
      [].concat(nextProps.projectBusinessUnits.data) : this.state.projectBusinessUnits;
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
    const query = decodeSearch(this.props.location.search);
    if (
        (query.projectStatus && query.projectStatus.length > 0) ||
        (query.projectBusinessUnit && query.projectBusinessUnit.length > 0) ||
        (query.projectState && query.projectState.length > 0) ||
        (query.dateRange && query.dateRange.length > 0) ||
        (query.dateFrom && query.dateFrom.length > 0) ||
        (query.dateTo && query.dateTo.length > 0)
      ) {
      this.setState({
        advanceFilter: true,
        projectBusinessUnits,
      });
    }
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getCoverPicture = (pictures) => {
    if (pictures && pictures.length > 0 && pictures.some(pp => pp.isCover === true)) {
      return pictures.find(pp => pp.isCover === true).picture;
    }
    return null;
  }
  async fetchPinnedProject(id) {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    let token;
    try {
      res = await store.dispatch(fetchM(`/project_pins/${id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return null;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      token = res.headers.get('X-Csrf-Token');
    }
    return token;
  }
  async pinProject(projectID) {
    const { store } = this.context;
    const { t, projectPinsToken } = this.props;
    await this.setLoading(true);
    try {
      await store.dispatch(fetchM('/project_pins/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': projectPinsToken,
        },
        body: JSON.stringify({
          projectID,
        }),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        if (err.res.status === 412) {
          await store.dispatch(flashErrorMessage({
            header: t('Pin limit reached', { ns: TRANSLATION_FILES.translation }),
            message,
          }));
        } else {
          await store.dispatch(flashErrorMessage({ message }));
        }
        await this.setLoading(false);
        return;
      }
      await store.dispatch(flashErrorMessage(err));
    }
    await this.setLoading(false);

    // refresh
    const query = decodeSearch(this.props.location.search);
    query.excludePinned = true;
    this.replaceQuery(query);

    await store.dispatch(flashSuccessMessage({
      header: t('Pin Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Project successfully pinned to top', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  async unpinProject(id) {
    const { store } = this.context;
    const { t } = this.props;
    const { pinnedData } = this.state;

    // find pinned project id
    let uppID = '';
    const matchedProject = pinnedData.find(pp => pp.projectID === id);
    if (matchedProject) {
      uppID = matchedProject.id;
    } else {
      return;
    }
    const uppToken = await this.fetchPinnedProject(uppID);

    await this.setLoading(true);
    try {
      await store.dispatch(fetchM(`/project_pins/${uppID}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': uppToken,
        },
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        await store.dispatch(flashErrorMessage({ message }));
        await this.setLoading(false);
        return;
      }
      await store.dispatch(flashErrorMessage(err));
    }
    await this.setLoading(false);

    // refresh
    const query = decodeSearch(this.props.location.search);
    query.excludePinned = true;
    this.replaceQuery(query);

    await store.dispatch(flashSuccessMessage({
      header: t('Unpin Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Project successfully unpinned', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  hasAccess(check = false, admin = true, dhq = true, dbl = true) {
    const auth = this.props.auth;
    if (admin && auth.isSuperAdmin) {
      return true;
    }
    if (dhq && auth.isHeadquarters) {
      return true;
    }
    if (dbl && auth.isBranchLeader) {
      return true;
    }
    return check;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleSetDateRange = (from, to) => {
    const query = decodeSearch(this.props.location.search);
    query.dateFrom = from;
    query.dateTo = to;
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handlePinProject = (e, project) => {
    e.preventDefault();
    if (project.pinned) {
      this.unpinProject(project.id);
    } else {
      this.pinProject(project.id);
    }
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`/projects/?${encodeSearch(queryNew)}`));
  }
  sortItems = [
    {
      text: 'Name Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'project.name',
      sortDirection: 'asc',
    },
    {
      text: 'Name Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'project.name',
      sortDirection: 'desc',
    },
    {
      text: 'Status Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'project.status_id',
      sortDirection: 'asc',
    },
    {
      text: 'Status Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'project.status_id',
      sortDirection: 'desc',
    },
    {
      text: 'Owner\'s Business Unit Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'project.ma_owner_company_branch_short_name',
      sortDirection: 'asc',
    },
    {
      text: 'Owner\'s Business Unit Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'project.ma_owner_company_branch_short_name',
      sortDirection: 'desc',
    },
    {
      text: 'Published Date (Newest)',
      icon: 'sort alphabet ascending',
      sortColumn: 'project.published_at',
      sortDirection: 'desc',
    },
    {
      text: 'Published Date (Oldest)',
      icon: 'sort alphabet descending',
      sortColumn: 'project.published_at',
      sortDirection: 'asc',
    },
  ];
  showProjectStatus = (statusID) => {
    const { t } = this.props;
    switch (statusID) {
      case 'draft':
        return t('Draft', { ns: TRANSLATION_FILES.constants });
      case 'ready':
        return t('Ready', { ns: TRANSLATION_FILES.constants });
      case 'published':
        return t('Published', { ns: TRANSLATION_FILES.constants });
      case 'archived':
        return t('Archived', { ns: TRANSLATION_FILES.constants });
      case 'deleted':
        return t('Deleted', { ns: TRANSLATION_FILES.constants });
      default:
        return null;
    }
  }
  showProjectStatusColor = (statusID) => {
    switch (statusID) {
      case 'draft':
        return '#9CAAC1';
      case 'ready':
        return '#F79A3E';
      case 'published':
        return '#50B793';
      case 'archived':
        return '#E7EAED';
      case 'deleted':
        return '#FF796E';
      default:
        return null;
    }
  }
  getSizeSuffix = (value) => {
    const { t } = this.props;
    switch (value) {
      case 'square_metres':
        return isCountryVietnam(this.props.auth && this.props.auth.company && this.props.auth.company.countryCode)
          ? 'm²'
          : t('sqm', { ns: TRANSLATION_FILES.screens });
      case 'square_feet':
        return t('sqft', { ns: TRANSLATION_FILES.screens });
      default:
        return '';
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Projects')}
          rightNav={this.hasAccess(this.props.auth.isBranchLeaderSupervisorII, true, true, false) ?
            <Menu.Item fitted>
              <Button
                as={Link}
                primary
                icon="add"
                content={t('Project')}
                disabled={this.state.loading}
                to={'/projects/new/'}
                // href={`${config.get('developerURL')}/c/${this.props.auth.company.service_company_id}/projects/new/`}
              />
            </Menu.Item> : null
          }
        />
        <Grid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column width={16}>
              <SearchFilter
                advanceFilter={this.state.advanceFilter}
                isLoading={this.state.loading}
                onChange={this.handleFilterOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                setAdvanceFilter={this.handleSetAdvanceFilter}
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              >
                <DatePicker
                  filterName="dateRange"
                  filterNameFrom="dateFrom"
                  filterNameTo="dateTo"
                  dateFrom={this.state.dateFrom}
                  dateTo={this.state.dateTo}
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  onResetRange={this.handleClearFilter}
                  onSetRange={this.handleSetDateRange}
                  options={DATE_RANGES.map(o => ({
                    ...o,
                    text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                  }))}
                  value={this.state.dateRange}
                />
                {
                  this.hasAccess() ? (
                    <SelectListMultiple
                      filterName="projectStatus"
                      hasSearch
                      headerText={t('Select Project Status')}
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={PROJECT_STATUSES.map(status => ({
                        ...status,
                        text: t(status.text, { ns: TRANSLATION_FILES.constants }),
                      }))}
                      placeholder={t('Select Project Status')}
                      value={this.state.projectStatus}
                    />
                  ) : null
                }
                {
                  this.hasAccess() && this.props.projectBusinessUnits && this.props.projectBusinessUnits.data && this.props.projectBusinessUnits.data[0] !== null ? (
                    <SelectListMultiple
                      filterName="projectBusinessUnit"
                      hasSearch
                      headerText={t('Select Business Unit')}
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={this.props.projectBusinessUnits.data.map(pbu => ({
                        value: pbu.MaOwnerCompanyBranchID.toString(),
                        text: pbu.MaOwnerCompanyBranchShortName,
                      }))}
                      placeholder={t('Select Business Unit')}
                      value={this.state.projectBusinessUnit}
                    />
                  ) : null
                }
                {this.props.auth.company.countryCode.toUpperCase() === 'MY' && (
                  <SelectListMultiple
                    filterName="projectState"
                    hasSearch
                    headerText={t('Select State')}
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    options={STATES}
                    placeholder={t('Select State')}
                    value={this.state.projectState}
                  />
                )}
              </SearchFilter>
            </Grid.Column>
          </Grid.Row>

          {/* Project List */}
          <Grid.Row>
            <Grid.Column>
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={this.state.loading && this.state.data.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              {
                this.state.data.length > 0 ?
                  <Grid columns={2} stackable equal>
                    {this.state.data.map((data, idx) => (
                      <Grid.Column key={idx} as={Link} to={`/projects/${data.id}/`}>
                        <div className="card-container">

                          {/* right side */}
                          <div className="image-container">
                            <LoadImage
                              inline
                              centered
                              loading={this.state.loading}
                              notFoundNode={
                                <img
                                  alt="default"
                                  src="/assets/images/projects/default-project.svg"
                                  className="default-img"
                                />
                                }
                              picture={this.getCoverPicture(data.projectPictures)}
                              pictureSize={70}
                            />
                            { this.hasAccess() && (
                              <Label
                                size="mini"
                                className="status-label"
                                style={{ backgroundColor: this.showProjectStatusColor(data.statusID) }}
                              >
                                {this.showProjectStatus(data.statusID)}
                              </Label>
                            )}
                            <Popup
                              trigger={
                                <div
                                  onClick={e => this.handlePinProject(e, data)}
                                  disabled={this.state.loading}
                                  role="button"
                                  className="bookmark-icon"
                                >
                                  <img
                                    alt="bookmark"
                                    src={`/assets/icons/bookmark-${data.pinned ? 'active' : 'inactive'}.svg`}
                                  />
                                </div>
                                }
                              content={data.pinned ? t('Unpin', { ns: TRANSLATION_FILES.constants }) : t('Pin to top', { ns: TRANSLATION_FILES.constants })}
                              position="bottom center"
                              className="custom-popup"
                            />
                          </div>

                          {/* left side */}
                          <div className="info-container">
                            <Grid.Column width={16} className="name">
                              {data.name}
                            </Grid.Column>

                            <Grid.Column width={16} className="info">
                              {data.address6 ? `${data.address6}, ` : ''}{data.address7}
                            </Grid.Column>

                            <Grid columns={2} className="info">
                              <Grid.Row columns="equal">
                                {/* Units */}
                                {
                                  data.summary &&
                                  <Grid.Column width={7}>
                                    <div className="item">
                                      <div className="icon">
                                        <img
                                          alt="available_units"
                                          src="/assets/icons/properties.svg"
                                        />
                                      </div>
                                      <Grid.Column>
                                        <div className="title">
                                          {t('Units', { ns: TRANSLATION_FILES.screens })}
                                        </div>
                                        <div className="value">
                                          {data.summary.newUnits}
                                          {data.summary.totalUnits && data.summary.newUnits > 0
                                            ? ` / ${data.summary.totalUnits}`
                                            : ''}
                                        </div>
                                      </Grid.Column>
                                    </div>
                                  </Grid.Column>
                                }
                                {/* Size */}
                                {
                                  (data.minSize > 0 || data.summary.minSize > 0 || data.maxSize > 0 || data.summary.maxSize > 0) && (
                                    <Grid.Column width={9}>
                                      <div className="item">
                                        <div className="icon">
                                          <img
                                            alt="size"
                                            src="/assets/icons/bounding_box.svg"
                                          />
                                        </div>
                                        <Grid.Column>
                                          <div className="title">
                                            {t('Size', { ns: TRANSLATION_FILES.screens })} ({this.getSizeSuffix(data.sizeSuffix)})
                                          </div>
                                          <div className="value">
                                            {
                                              data.minSize > 0 || data.summary.minSize > 0 ?
                                                <SizeSuffix
                                                  size={data.manualSize ?
                                                    data.minSize : data.summary.minSize}
                                                />
                                              : null
                                            }
                                            {
                                              (data.minSize > 0 || data.summary.minSize > 0) &&
                                              (data.maxSize > 0 || data.summary.maxSize > 0) &&
                                              (data.maxSize !== data.minSize ||
                                              data.summary.maxSize !== data.summary.minSize) ?
                                              ' - ' : null
                                            }
                                            {
                                              (data.maxSize > 0 || data.summary.maxSize > 0) &&
                                              (data.maxSize !== data.minSize ||
                                              data.summary.maxSize !== data.summary.minSize) ?
                                                <SizeSuffix
                                                  size={data.manualSize ?
                                                    data.maxSize : data.summary.maxSize}
                                                />
                                              : null
                                            }
                                          </div>
                                        </Grid.Column>
                                      </div>
                                    </Grid.Column>
                                  )
                                }
                                {/* Price */}
                                {(data.minPrice > 0 || data.summary.minPrice > 0 || data.maxPrice > 0 || data.summary.maxPrice > 0) && (
                                  <Grid.Column width={16}>
                                    <div className="item">
                                      <Grid.Column>
                                        <div className="title">{t('Price', { ns: TRANSLATION_FILES.screens })}</div>
                                        <div className="value">
                                          {data.minPrice > 0 || data.summary.minPrice > 0 ? (
                                            <LoanAmount
                                              format="0,0"
                                              amount={data.manualPrice ? data.minPrice : data.summary.minPrice}
                                              projectCurrencies={data.projectCurrency}
                                              prefix={<CurrencySymbol />}
                                            />
                                          ) : null}
                                          {(data.minPrice > 0 || data.summary.minPrice > 0) &&
                                          (data.maxPrice > 0 || data.summary.maxPrice > 0) &&
                                          (data.maxPrice !== data.minPrice || data.summary.maxPrice !== data.summary.minPrice)
                                            ? ' - '
                                            : null}
                                          {(data.maxPrice > 0 || data.summary.maxPrice > 0) &&
                                          (data.maxPrice !== data.minPrice || data.summary.maxPrice !== data.summary.minPrice) ? (
                                            <LoanAmount
                                              format="0,0"
                                              amount={data.manualPrice ? data.maxPrice : data.summary.maxPrice}
                                              projectCurrencies={data.projectCurrency}
                                            />
                                          ) : null}
                                        </div>
                                      </Grid.Column>
                                    </div>
                                  </Grid.Column>
                                )}
                              </Grid.Row>
                            </Grid>
                            <Grid.Column width={16} className="label-group">
                              <Label.Group size="mini">
                                {data.isResidential ? <Label basic as="a">{t('Residential')}</Label> : null}
                                {data.isIndustrial ? <Label basic as="a">{t('Industrial')}</Label> : null}
                                {data.isCommercial ? <Label basic as="a">{t('Commercial')}</Label> : null}
                                {data.maOwnerCompanyBranchShortName ? <Label className="bu-label" onClick={() => { this.handleFilterOnChange(data.maOwnerCompanyBranchID, 'projectBusinessUnit[0]'); }} as="a">{data.maOwnerCompanyBranchShortName}</Label> : null}
                              </Label.Group>
                            </Grid.Column>
                          </div>
                        </div>
                      </Grid.Column>
                    ))}
                  </Grid>
                  : (
                    <Item>
                      <Item.Content>
                        <Segment textAlign="center">
                          {
                            this.state.loading ?
                              <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                            : `${t('No projects found')}.`
                          }
                        </Segment>
                      </Item.Content>
                    </Item>
                  )
                }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <PageNav
                upward
                currentPage={this.state.currentPage}
                count={this.state.count}
                limit={this.state.limit}
                offset={this.state.offset}
                dataSize={this.state.data.length}
                loading={this.state.loading}
                onChange={this.handleChangePage}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(List.mapStateToProps)(List));



// WEBPACK FOOTER //
// ./src/containers/Projects/List.jsx